import PropTypes from 'prop-types';
import React from 'react';
import TrueLinkMaskedTextInput from 'react/shared/components/true_link/main/form/masked_text_input/TrueLinkMaskedTextInput';
import CardText from 'react/shared/components/true_link/main/form/wizard/CardText';
import LockAdornment from 'react/signups/card/common/LockAdornment';
import SecurityInfo from 'react/signups/card/common/SecurityInfo';

export default function VerifyMyselfForm({ onChange, setFieldTouched, values }) {
  return (
    <>
      <CardText>
        Federal regulation requires us to gather this information. It will only be used to verify
        your identity and will not impact your credit score.
      </CardText>
      <TrueLinkMaskedTextInput
        endAdornment={<LockAdornment />}
        labelText="Your Social Security Number"
        mask="999-99-9999"
        name="ssn"
        onChange={onChange}
        placeholder="XXX-XX-XXXX"
        required
        setFieldTouched={setFieldTouched}
        value={values.ssn}
      />
      <TrueLinkMaskedTextInput
        endAdornment={<LockAdornment />}
        labelText="Confirm your Social Security Number"
        mask="999-99-9999"
        name="ssnConfirmation"
        onChange={onChange}
        placeholder="XXX-XX-XXXX"
        required
        setFieldTouched={setFieldTouched}
        value={values.ssnConfirmation}
      />
      <TrueLinkMaskedTextInput
        labelText="Your date of birth"
        mask="99/99/9999"
        name="dateOfBirth"
        onChange={onChange}
        placeholder="MM/DD/YYYY"
        required
        setFieldTouched={setFieldTouched}
        value={values.dateOfBirth}
      />
      <SecurityInfo />
    </>
  );
}

VerifyMyselfForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  values: PropTypes.shape({
    ssn: PropTypes.string.isRequired,
    ssnConfirmation: PropTypes.string.isRequired,
    dateOfBirth: PropTypes.string.isRequired,
  }).isRequired,
};
